import CustomButton from "../../../../components/CustomButton";
import userRoles from "../../../../constants/userRoles";
import { adminRoutes } from "../../../../router/routesConstants";
import usePermissions from "../../../../router/usePermissions";
import Text from "../../../../styleguide/Text";

function CellsNomenclatureCustomHeader() {
  const { isAuthorized } = usePermissions();

  const goToCreateVerificationZone = () => {
    return `/${adminRoutes.cellsNomenclature}/${adminRoutes.createCellNomenclature}`;
  };

  return (
    <div className="flex flex-wrap justify-between items-center gap-3 mb-6">
      <Text
        variant="h3"
        component="h3"
        className="font-semibold text-slate-900">
        Nomenclator celule
      </Text>
      {isAuthorized(userRoles.EDIT_CELL_NOMENCLATURE) && (
        <CustomButton
          variant="contained"
          icon="ADD"
          tooltipTitle="Deschide formularul de adaugare a unei celule."
          navigate={goToCreateVerificationZone()}>
          Adauga celula
        </CustomButton>
      )}
    </div>
  );
}

export default CellsNomenclatureCustomHeader;
